import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "16",
            height: "10",
            x: "2",
            y: "7",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "22", y1: "11", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "11", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "11", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "14", y1: "11", y2: "13", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BatteryFull";
const BatteryFull = memo(themed(Icon));
export {
  BatteryFull
};
//# sourceMappingURL=battery-full.js.map
